import React from "react";

const SupportList = () => {
  const mail = "servicedesk@vetropack.com";
  const website = "https://www.vetropack.com/";

  return (
    <ul className="support-list">
      <li className="support-list__item">
        <a href={`mailto:${mail}`}>
          <span className="ficon ficon__mail support-list__mail-icon" />
          {mail}
        </a>
      </li>
      <li className="support-list__item" style={{ borderLeft: "0" }}>
        <a href={website}>{website}</a>
      </li>
    </ul>
  );
};

export default SupportList;
